import { render } from "./SystemUpdate.vue?vue&type=template&id=930d67bc&scoped=true"
import script from "./SystemUpdate.vue?vue&type=script&lang=js"
export * from "./SystemUpdate.vue?vue&type=script&lang=js"

import "./SystemUpdate.vue?vue&type=style&index=0&id=930d67bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-930d67bc"]])

export default __exports__